// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.page-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
    font-family: 'Poppins', sans-serif;
}

.search-input {
    width: 300px;
}

.add-category-card {
    background: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.add-category-card:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.categories-list-card {
    background: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.categories-table {
    margin: 0;
    border-collapse: separate;
    border-spacing: 0 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
}

.categories-table thead th {
    background: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    color: #495057;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 1rem;
}

.category-row {
    transition: all 0.2s ease;
    animation: fadeIn 0.3s ease;
}

.category-row:hover {
    background-color: #f8f9fa;
}

.category-row td {
    padding: 1rem;
    vertical-align: middle;
}

.category-name {
    display: flex;
    align-items: center;
    position: relative;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 0.95rem;
    font-weight: 500;
}

.category-row .category-name::before {
    content: '';
    position: absolute;
    left: 12px;
    top: 50%;
    width: 16px;
    height: 1px;
    background-color: #dee2e6;
    display: none;
}

.category-row.nested .category-name::before {
    display: block;
}


.expand-button {
    background-color: #f1f3f5;
    border: 1px solid #dee2e6;
    color: #495057;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.expand-button:hover:not(:disabled) {
    background-color: #e9ecef;
    color: #212529;
}

.expand-button.invisible {
    visibility: hidden;
}

.expand-button:disabled {
    cursor: default;
}

.action-buttons {
    display: flex;
    gap: 8px;
}

.action-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.2s ease;
    font-family: 'Plus Jakarta Sans', sans-serif;
}

.action-button svg {
    width: 16px;
    height: 16px;
}

.edit-button {
    background-color: #0d6efd;
    border-color: #0d6efd;
    color: white;
}

.edit-button:hover {
    background-color: #0b5ed7;
    border-color: #0a58ca;
    transform: translateY(-1px);
}

.delete-button {
    background-color: #dc3545;
    border-color: #dc3545;
    color: white;
}

.delete-button:hover {
    background-color: #bb2d3b;
    border-color: #b02a37;
    transform: translateY(-1px);
}

.expanded {
    background-color: #f8f9fa;
}


@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.category-row.expanded {
    background-color: #f8f9fa;
}

.category-row.expanded > td {
    border-bottom: 2px solid #e9ecef;
}

/* Loading spinner customization */
.spinner-border {
    width: 3rem;
    height: 3rem;
    color: #007bff;
}

/* Form controls styling */
.form-control, .form-select {
    border: 1px solid #dee2e6;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    transition: all 0.2s ease;
}

.form-control:focus, .form-select:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Button customization */
.btn-primary {
    background-color: #007bff;
    border-color: #007bff;
    transition: all 0.2s ease;
}

.btn-primary:hover {
    background-color: #0056b3;
    border-color: #0056b3;
    transform: translateY(-1px);
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .search-input {
        width: 100%;
    }

    .action-button span {
        display: none;
    }

    .action-button {
        padding: 6px;
    }
}

/* Add these new styles for the modal */
.modal-content {
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
    border-bottom: 1px solid #eee;
    padding: 1rem 1.5rem;
}

.modal-header .modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
}

.modal-body {
    padding: 1.5rem;
}

.modal-footer {
    border-top: 1px solid #eee;
    padding: 1rem 1.5rem;
}

.modal .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
}

.modal .form-control:focus,
.modal .form-select:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Category counter badge */
.category-count {
    font-size: 0.75rem;
    color: #6c757d;
    background-color: #e9ecef;
    padding: 2px 6px;
    border-radius: 12px;
    margin-left: 8px;
}

/* Visual hierarchy improvements */
.fw-semibold {
    font-weight: 600;
}

.text-muted {
    color: #6c757d !important;
}

/* Nested category lines */
.nested-line {
    position: absolute;
    left: -12px;
    top: 50%;
    width: 12px;
    height: 1px;
    background-color: #dee2e6;
}

.nested-line::before {
    content: '';
    position: absolute;
    left: 0;
    top: -8px;
    width: 1px;
    height: 16px;
    background-color: #dee2e6;
}

.nested-line-container {
    position: relative;
}

.nested-line {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
    background-color: #dee2e6;
}

.nested-line::before {
    content: '';
    position: absolute;
    left: 0;
    top: -12px;
    width: 1px;
    height: 24px;
    background-color: #dee2e6;
}


.categories-table tbody tr {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
}

.categories-table tbody tr:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}

.categories-table td {
    background-color: #ffffff;
    border: none;
}

.categories-table td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.categories-table td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/Categories.css"],"names":[],"mappings":"AAAA;IACI,uKAAuK;AAC3K;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,SAAS;IACT,yBAAyB;IACzB,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,4CAA4C;IAC5C,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA,kCAAkC;AAClC;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;;IAEI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;;AAGA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC","sourcesContent":["body {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.page-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #2c3e50;\n    margin: 0;\n    font-family: 'Poppins', sans-serif;\n}\n\n.search-input {\n    width: 300px;\n}\n\n.add-category-card {\n    background: #ffffff;\n    border: none;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: all 0.3s ease;\n}\n\n.add-category-card:hover {\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.categories-list-card {\n    background: #ffffff;\n    border: none;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.categories-table {\n    margin: 0;\n    border-collapse: separate;\n    border-spacing: 0 8px;\n    font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.categories-table thead th {\n    background: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n    color: #495057;\n    font-family: 'Plus Jakarta Sans', sans-serif;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 1rem;\n}\n\n.category-row {\n    transition: all 0.2s ease;\n    animation: fadeIn 0.3s ease;\n}\n\n.category-row:hover {\n    background-color: #f8f9fa;\n}\n\n.category-row td {\n    padding: 1rem;\n    vertical-align: middle;\n}\n\n.category-name {\n    display: flex;\n    align-items: center;\n    position: relative;\n    font-family: 'Plus Jakarta Sans', sans-serif;\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.category-row .category-name::before {\n    content: '';\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    width: 16px;\n    height: 1px;\n    background-color: #dee2e6;\n    display: none;\n}\n\n.category-row.nested .category-name::before {\n    display: block;\n}\n\n\n.expand-button {\n    background-color: #f1f3f5;\n    border: 1px solid #dee2e6;\n    color: #495057;\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n}\n\n.expand-button:hover:not(:disabled) {\n    background-color: #e9ecef;\n    color: #212529;\n}\n\n.expand-button.invisible {\n    visibility: hidden;\n}\n\n.expand-button:disabled {\n    cursor: default;\n}\n\n.action-buttons {\n    display: flex;\n    gap: 8px;\n}\n\n.action-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.action-button svg {\n    width: 16px;\n    height: 16px;\n}\n\n.edit-button {\n    background-color: #0d6efd;\n    border-color: #0d6efd;\n    color: white;\n}\n\n.edit-button:hover {\n    background-color: #0b5ed7;\n    border-color: #0a58ca;\n    transform: translateY(-1px);\n}\n\n.delete-button {\n    background-color: #dc3545;\n    border-color: #dc3545;\n    color: white;\n}\n\n.delete-button:hover {\n    background-color: #bb2d3b;\n    border-color: #b02a37;\n    transform: translateY(-1px);\n}\n\n.expanded {\n    background-color: #f8f9fa;\n}\n\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.category-row.expanded {\n    background-color: #f8f9fa;\n}\n\n.category-row.expanded > td {\n    border-bottom: 2px solid #e9ecef;\n}\n\n/* Loading spinner customization */\n.spinner-border {\n    width: 3rem;\n    height: 3rem;\n    color: #007bff;\n}\n\n/* Form controls styling */\n.form-control, .form-select {\n    border: 1px solid #dee2e6;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.875rem;\n    transition: all 0.2s ease;\n}\n\n.form-control:focus, .form-select:focus {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Button customization */\n.btn-primary {\n    background-color: #007bff;\n    border-color: #007bff;\n    transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n    background-color: #0056b3;\n    border-color: #0056b3;\n    transform: translateY(-1px);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .search-input {\n        width: 100%;\n    }\n\n    .action-button span {\n        display: none;\n    }\n\n    .action-button {\n        padding: 6px;\n    }\n}\n\n/* Add these new styles for the modal */\n.modal-content {\n    border-radius: 8px;\n    border: none;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n    border-bottom: 1px solid #eee;\n    padding: 1rem 1.5rem;\n}\n\n.modal-header .modal-title {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #2c3e50;\n}\n\n.modal-body {\n    padding: 1.5rem;\n}\n\n.modal-footer {\n    border-top: 1px solid #eee;\n    padding: 1rem 1.5rem;\n}\n\n.modal .btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n}\n\n.modal .form-control:focus,\n.modal .form-select:focus {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Category counter badge */\n.category-count {\n    font-size: 0.75rem;\n    color: #6c757d;\n    background-color: #e9ecef;\n    padding: 2px 6px;\n    border-radius: 12px;\n    margin-left: 8px;\n}\n\n/* Visual hierarchy improvements */\n.fw-semibold {\n    font-weight: 600;\n}\n\n.text-muted {\n    color: #6c757d !important;\n}\n\n/* Nested category lines */\n.nested-line {\n    position: absolute;\n    left: -12px;\n    top: 50%;\n    width: 12px;\n    height: 1px;\n    background-color: #dee2e6;\n}\n\n.nested-line::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: -8px;\n    width: 1px;\n    height: 16px;\n    background-color: #dee2e6;\n}\n\n.nested-line-container {\n    position: relative;\n}\n\n.nested-line {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    width: 100%;\n    height: 1px;\n    background-color: #dee2e6;\n}\n\n.nested-line::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: -12px;\n    width: 1px;\n    height: 24px;\n    background-color: #dee2e6;\n}\n\n\n.categories-table tbody tr {\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n}\n\n.categories-table tbody tr:hover {\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n    transform: translateY(-2px);\n}\n\n.categories-table td {\n    background-color: #ffffff;\n    border: none;\n}\n\n.categories-table td:first-child {\n    border-top-left-radius: 8px;\n    border-bottom-left-radius: 8px;\n}\n\n.categories-table td:last-child {\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
